import React from 'react';

const JS_Screen = () => {
  return (
    <div >
      <h1>JS_Screen</h1>
      <p>Placeholder component for: "JS Screen"</p>
    </div>
  );
};

export default JS_Screen;
